import { supabase } from '../clients/supabaseClient';
import type { ProductEnrichment } from '../types';

/**
 * Fetches the enrichment record for a product, if one exists and has been
 * successfully matched (match_status = 'matched'). Unmatched/ambiguous rows
 * are intentionally excluded here — those are internal data-quality states,
 * not something to surface on a product's detail page. If a product ever
 * ends up with more than one matched enrichment row (shouldn't normally
 * happen, but nothing in the schema strictly prevents it), the most
 * recently updated one wins.
 */
export async function fetchProductEnrichment(
    productId: string,
): Promise<ProductEnrichment | null> {
    const { data, error } = await supabase
        .from('product_enrichment')
        .select('*')
        .eq('product_id', productId)
        .eq('match_status', 'matched')
        .order('updated_at', { ascending: false })
        .limit(1);

    if (error) throw error;
    return data?.[0] ?? null;
}